import { InternalProduct } from '../models/product/types';
import { LiveGuidelineProduct } from '../redux/actions/liveGuidelineActions/types';

// Guideline products have no project; `id` is the guideline product id and `liveGuidelineId` marks the scope.
export const toGuidelineInternalProduct = (lgp: LiveGuidelineProduct) =>
    ({
        id: lgp.id,
        productId: lgp.productId!,
        dateAdded: lgp.dateAdded,
        isHidden: lgp.isHidden,
        hiddenOn: lgp.hiddenOn,
        storage: 'TC',
        projectId: 0,
        lastUpdated: lgp.hiddenOn || lgp.dateAdded || '',
        isDeleted: lgp.isDeleted ?? false,
        isInstalled: false,
        isMyFavorite: false,
        isOfficeFavorite: false,
        commentsCount: lgp.commentsCount ?? 0,
        documentsCount: lgp.documentsCount ?? 0,
        imagesCount: lgp.imagesCount ?? 0,
        documentTypes: lgp.documentTypes ?? [],
        liveGuidelineId: lgp.liveGuidelineId,
        createdBy: '',
    }) as unknown as InternalProduct;
